const BlankLayout = ({ children }: { children: React.ReactNode }) => {
    return <>
        {children}
    </>
}

export default BlankLayout